export interface Unit {
  unitCode: string;
  unitDesc: string;
  unitId: number;
}
